import { render, staticRenderFns } from "./KeyboardShortcuts.vue?vue&type=template&id=ed3be7c8"
import script from "./KeyboardShortcuts.vue?vue&type=script&lang=js"
export * from "./KeyboardShortcuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports